import React from "react"
import Header from "../components/Global/Header/Header"
import Footer from "../components/Global/Footer/Footer"
import LandingHeader from "../components/Global/Landing/LandingHeader"
import LandingFooter from "../components/Global/Landing/LandingFooter"
import { useSiteQueryThree } from "../hooks/layout/useSiteQueryThree"

const Layout = ({ children, isLandingPage = false }) => {
  const { skipToContent } = useSiteQueryThree()

  const HeaderComponent = isLandingPage ? LandingHeader : Header
  const FooterComponent = isLandingPage ? LandingFooter : Footer

  return (
    <div className="layout--container bg-white">
      <a href="#main" className="skip-to-content">
        {skipToContent}
      </a>

      <HeaderComponent />
      <main className="max-w-container" id="main">
        {children}
      </main>
      <FooterComponent />
    </div>
  )
}

export default Layout
